
export enum PasswordInputIcon {
    ShowEnabled = "/images/forms/show-password-enabled.svg",
    ShowDisabled = "/images/forms/show-password-disabled.svg",
    HideEnabled = "/images/forms/hide-password-enabled.svg",
    HideDisabled = "/images/forms/hide-password-disabled.svg",
}